import { twMerge } from 'tailwind-merge';
import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';

export const FilterEmptyIcon = ({ color = Color.Gray600, className }: NewIconProps) => (
  <svg
    className={twMerge('size-[20px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="icon">
      <g id="ico">
        <path
          id="Vector 2 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.64299 5.14014L11.7396 5.14014V6.34014L2.64299 6.34014V5.14014Z"
          fill={color}
        />
        <path
          id="Vector 3 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.64209 9.78662H8.79579V10.9866H2.64209V9.78662Z"
          fill={color}
        />
        <path
          id="Vector 4 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.64309 14.4907H7.05751V15.6907H2.64309V14.4907Z"
          fill={color}
        />
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0477 14.553L16.9323 12.6683L17.7808 13.5168L14.4478 16.85L11.1147 13.5168L11.9632 12.6683L13.8477 14.5528L13.8477 5H15.0477L15.0477 14.553Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

export const FilterIcon = ({ color, className }: NewIconProps) => (
  <FilterEmptyIcon color={color} className={className} />
);
